import { useState, useEffect } from "react";
import "../components/content_overlay_new.css";

function ContentOverlayNew({ heading, text_content }) {
  return (
    <div id="background_image_for_content">
      <div id="content-overlay2">
        <h2>{heading}</h2>
        <div className="row" style={{ display: "flex", gap: "20px" }}>
          {text_content}
        </div>
      </div>
    </div>
  );
}

export default ContentOverlayNew;
